import React from "react";
import { Row, Label, Button, Col } from "reactstrap";
import { toast } from "react-toastify";

import { ContractServicesService } from "../../services/contract-service/contractServices";
import { dictionary } from "../../utilities/dictionary";
import { useAppContext } from "../../AppProvider";
import { callErrorToast } from "../../utilities";

const contractServicesService = new ContractServicesService();

const Delete = ({ contractServiceId, modalToogle, refreshTable }) => {
  const { dictionary } = useAppContext();
  const deleteContractService = () => {
    contractServicesService
      .deleteContractService(contractServiceId)
      .then((response) => {
        refreshTable();
        modalToogle();
        toast.success(dictionary.messages.item_deleted_successfully, {
          position: toast.POSITION.TOP_CENTER,
        });
      })
      .catch((err) => {
        callErrorToast(err, dictionary);
      });
  };

  return (
    <React.Fragment>
      <div className="row mb-3">
        <div className="col">
          <label>{dictionary.messages.ask_to_delete}</label>
        </div>
      </div>
      <div className="d-flex justify-content-end">
        <button
          className="btn btn-link"
          onClick={() => {
            modalToogle();
            refreshTable();
          }}
        >
          {dictionary.actions.cancel}
        </button>
        <Button className="btn btn-danger ms-3" onClick={deleteContractService}>
          {dictionary.actions.delete}
        </Button>
      </div>
    </React.Fragment>
  );
};

export default Delete;
